import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchArticlePrices, deleteArticlePrice } from 'store/actions';

// Import translation
import { useTranslation } from 'react-i18next';

// Import columns
import { createColumns } from 'components/helpers/columns/prices';

// Import components
import { TableTemplate } from 'components/common/templates';

const ArticlesPrices = ({
	error,
	fetchArticlePrices,
	deleteArticlePrice,
	resources,
	match: {
		params: { id }
	}
}) => {
	const { t } = useTranslation();

	return (
		// Dispatch fetchArticlePrices, deleteArticlePrice action in articles_prices
		<TableTemplate
			itemId={id}
			error={error}
			type={`articles/${id}/price`}
			typeText="prices"
			addLinkText={t('prices:buttons.add')}
			resources={resources}
			columns={createColumns}
			fetchResourcesAction={fetchArticlePrices}
			deleteItemAction={deleteArticlePrice}
			notificationDeleteSuccessTxt={t('prices:notification.delete_success')}
			notificationDeleteErrorTxt={t('prices:notification.delete_error')}
		></TableTemplate>
	);
};

ArticlesPrices.propTypes = {
	error: PropTypes.bool.isRequired,
	resources: PropTypes.object.isRequired,
	fetchArticlePrices: PropTypes.func.isRequired,
	deleteArticlePrice: PropTypes.func.isRequired,
	match: PropTypes.shape({
		params: PropTypes.shape({ id: PropTypes.string.isRequired })
	})
};

const mapStateToProps = ({ articles: { prices } }) => ({
	error: prices.error,
	resources: prices
});

export default compose(
	connect(mapStateToProps, { fetchArticlePrices, deleteArticlePrice }),
	withRouter
)(ArticlesPrices);
